import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const STRIPE_PAYMENT_SOURCES_API_NAME: string = 'stripe_payment_sources';
export const STRIPE_PAYMENT_SOURCES_API_ENDPOINT: string = environment.API_BASE_PATH + '/buyer-stripe-payment-source';

@Injectable({
  providedIn: 'root',
})
export class StripePaymentSourcesService {
  createPaymentSource(payment_source: StripePaymentSource): Observable<any> {
    const api_name: string = STRIPE_PAYMENT_SOURCES_API_NAME;
    const path: string = '';
    const init = {
      response: true,
      body: payment_source,
    };
    return from(API.post(api_name, path, init));
  }

  listPaymentSources(buyer_id: string): Observable<any> {
    const api_name: string = STRIPE_PAYMENT_SOURCES_API_NAME;
    const path: string = `/buyer/${buyer_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  deletePaymentSource(payment_source_id: string, buyer_id: string): Observable<any> {
    const api_name: string = STRIPE_PAYMENT_SOURCES_API_NAME;
    const path: string = `/${payment_source_id}/buyer/${buyer_id}`;
    const init = { response: true };
    return from(API.del(api_name, path, init));
  }
}

export interface StripePaymentSource {
  buyer_stripe_payment_source_id?: string;
  buyer_id?: string;
  livemode?: boolean;
  type?: StripePaymentSourceType;
  stripe_payment_method_id?: string;
  stripe_card?: StripeCard;
  stripe_sepa_debit?: StripeSepaDebit;
  is_default_source?: boolean;
}

export interface StripeCard {
  fingerprint?: string;
  brand?: string;
  country?: string;
  exp_month?: number;
  exp_year?: number;
  last4?: string;
  funding?: StripePaymentSourceFunding;
}

export interface StripeSepaDebit {
  fingerprint?: string;
  bank_code?: string;
  country?: string;
  last4?: string;
}

export enum StripePaymentSourceType {
  card = 'card',
  sepa = 'sepa_debit',
}

export enum StripePaymentSourceFunding {
  prepaid = 'prepaid',
  debit = 'debit',
  credit = 'credit',
}
